module.exports = __webpack_public_path__ + "static/media/published-posts.1ec124d3.svg";